<div class="wrapper" id="sports" loading="lazy">
  <h2>Our Sports</h2>
  <div class="cards">
    <div class="card" *ngFor="let sport of displayedSports">
      <div class="icon">
        <img [src]="sport.logo" alt="logo" />
        <h3>{{ sport.title }}</h3>
      </div>
    </div>
  </div>
</div>
